import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import React from 'react';
import { useHistory,useLocation} from 'react-router-dom';


const CreateConfirm = () => {
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const userId = queryParams.get('userId');
    const accountId = queryParams.get('accountId');
    const boardId = queryParams.get('boardId');
    const recipeId = queryParams.get('recipeId');

    // 👇 important (parse JSON)
    const accountData = JSON.parse(queryParams.get('accountData') || '[]');

    console.log(userId, accountId, boardId, recipeId, accountData,"servicenow config data");


    const buttonStyle = {
        borderRadius: '7px',
        width: '110px',
        height: '30px',
        backgroundColor: '#188754',
        color: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        border: 'none',
        outline: 'none',
        marginTop: '10px',
        fontSize: '15px',
    };

    // function getQueryVariable(variable) {

    //     const query = window.location.search.substring(1);
    //     // console.log(query)//"app=article&act=news_content&aid=160990"
    //     const vars = query.split('&');
    //     //  console.log(vars) //[ 'app=article', 'act=news_content', 'aid=160990' ]
    //     for (let i = 0; i < vars.length; i++) {
    //         const pair = vars[i].split('=');
    //         // console.log(pair)//[ 'app', 'article' ][ 'act', 'news_content' ][ 'aid', '160990' ] 
    //         if (pair[0] == variable) { return pair[1]; }
    //     }
    //     return (false);
    // }

    const handleCreate = () => {
      const url = `/BasicConfiguration?userId=${userId}
        &accountId=${accountId}
        &boardId=${boardId}
        &recipeId=${recipeId}
        &accountData=${encodeURIComponent(JSON.stringify(accountData))}`;
        // window.location = url;
        history.push(url);
    };

    return (
      <>
        <Container fluid>
          <Row className="justify-content-center align-items-center" style={{ height: '99vh', }}>

            <Col xs={6} md={6} lg={6} xl={8} style={{ backgroundColor: 'White', borderRadius: '20px', fontSize: '15px' }}>
              <div>
                <br />
                <h3 style={{ textAlign: 'center', color: '#188754', }}>
                                Setup ServiceNow Oauth
                </h3>
                <br />
                <div style={{ color: '#188754', border: '1px solid #188754', fontWeight: 'bold' }} />
                <br />
                <div style={{ padding: '1%', fontSize: '15px', }}>
                  <div>
                    <p>
                                        Using OAuth, you can pass a user ID and password once, and then use a token for subsequent REST requests instead of submitting credentials with each request.
                    </p>
                    <ol>
                      <li>Log in to the ServiceNow instance.</li>
                      <li>Activate the OAuth 2.0 plugin.</li>
                      <li>
                                            In the sys_properties table, set the system property
                        {' '}
                        <code style={{fontSize:'15px'}}>com.snc.platform.security.oauth.is.active</code>
                        {' '}
to true.
                      </li>
                      <li>
                                            Click 
                        {' '}
                        <strong>System OAuth &gt; Application Registry</strong>
.
                      </li>
                      <li>
                                            Click 
                        {' '}
                        <strong>NEW</strong>
                        {' '}
and then click an OAuth API endpoint for external clients.
                      </li>
                      <li>Specify the following parameters:</li>
                      <ul>
                        <li>
                            <strong>Name:</strong>
                            {' '}
Enter a unique name.
                          </li>
                        <li>
                            <strong>Client ID:</strong>
                            {' '}
Client ID automatically generated by ServiceNow OAuth server.
                          </li>
                        <li>
                            <strong>Client Secret Key:</strong>
                            {' '}
Client secret for the OAuth application.
                          </li>
                        <li>
                            <strong>Refresh Token Lifespan:</strong>
                            {' '}
Time in seconds the refresh token is valid.
                          </li>
                        <li>
                            <strong>Access Token Lifespan:</strong>
                            {' '}
Time in seconds the access token is valid.
                          </li>
                      </ul>
                      <li>Record the value of client ID and client Secret from the previous step.</li>
                      <li>
Click
                        <strong>Submit</strong>
.
                      </li>
                    </ol>
                  </div>


                </div>
                <div style={{ marginTop: '5px', marginBottom: '5px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button onClick={handleCreate} style={buttonStyle}>Continue</button>
                </div>

              </div>

            </Col>

          </Row>

        </Container>
      </>
    );
};

export default CreateConfirm;

